import { type PreLotteryProps } from "@hg/activity-utils"
import Scroll from "@hg/scroll"

import { CustomModal, ModalContent } from "@/components/Modal"
import { i18n } from "@/i18n"

import styles from "./index.module.scss"

const RuleContent = () => (
    <div className={styles.rules}>
        <Scroll direction="y" className={styles.scroll} rotateDetection>
            {i18n.getArray("lottery.rule.duration").map((item, index) => (
                <div
                    key={index}
                    className={styles.duration}
                    dangerouslySetInnerHTML={{
                        __html: item,
                    }}
                />
            ))}
            <div className={styles.section}>
                {i18n.get("lottery.rule.title_special_instructions")}
            </div>
            {i18n
                .getArray("lottery.rule.special_instructions")
                .map((item, index) => (
                    <div className={styles.ruleItem} key={item}>
                        <div className={styles.label}>0{index + 1}</div>
                        <div
                            className={styles.text}
                            dangerouslySetInnerHTML={{
                                __html: item,
                            }}
                        />
                    </div>
                ))}
            <div className={styles.section}>
                {i18n.get("lottery.rule.title_attention")}
            </div>
            {i18n.getArray("lottery.rule.attention").map((item, index) => (
                <div className={styles.ruleItem} key={item}>
                    <div className={styles.label}>0{index + 1}</div>
                    <div
                        className={styles.text}
                        dangerouslySetInnerHTML={{
                            __html: item,
                        }}
                    ></div>
                </div>
            ))}
            <div className={styles.section}>
                {i18n.get("lottery.rule.title_remind")}
            </div>
            {i18n.getArray("lottery.rule.remind").map((item, index) => (
                <div className={styles.ruleItem} key={item}>
                    <div className={styles.label}>0{index + 1}</div>
                    <div
                        className={styles.text}
                        dangerouslySetInnerHTML={{
                            __html: item,
                        }}
                    ></div>
                </div>
            ))}
        </Scroll>
    </div>
)

interface Props extends PreLotteryProps {
    showOkBtn?: boolean
}

export const Rule: React.FC<Props> = (props) => {
    const { onConfirm, onClose, showOkBtn = true } = props

    return (
        <ModalContent
            size="large"
            onCancel={onClose}
            showCancelBtn={false}
            showOkBtn={showOkBtn}
            okText={i18n.get("lottery.btn_confirm")}
            onOk={onConfirm}
        >
            <RuleContent />
        </ModalContent>
    )
}

interface RuleModalProps extends Props {
    open: boolean
}

export const RuleModal: React.FC<RuleModalProps> = (props) => {
    const { open, onConfirm, onClose, showOkBtn = true } = props

    return (
        <CustomModal
            open={open}
            size="large"
            onCancel={onClose}
            showCancelBtn={false}
            showOkBtn={showOkBtn}
            okText={i18n.get("lottery.btn_confirm")}
            onOk={onConfirm}
        >
            <RuleContent />
        </CustomModal>
    )
}
